// extracted by mini-css-extract-plugin
export var attachment = "_jf-a";
export var emailContainer = "_jf-4";
export var emailContentPaddedContainer = "_jf-b";
export var emailHeader = "_jf-6";
export var emailIframe = "_jf-3";
export var emailInfoIcon = "_jf-9";
export var emailShortenedSummary = "_jf-e";
export var infoDropdown = "_jf-0";
export var infoRowBoundedContent = "_jf-d";
export var internal = "_jf-5";
export var merchant = "_jf-8";
export var messageInputContainer = "_jf-h";
export var normal = "_jf-7";
export var replyCard = "_jf-f";
export var subtleButton = "_jf-1";
export var subtleButtonIconContainer = "_jf-2";
export var toggleViewRepliesButton = "_jf-c";
export var wrappingText = "_jf-g";